<template>
  <div>
    <b-dropdown aria-role="list">
      <button slot="trigger" slot-scope="{ active }" class="button">
        <span>Actions</span>
        <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
      </button>
      <b-dropdown-item aria-role="listitem">
        <a href="" @click.prevent="moveToRoster(entry)">Move to Roster</a>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" v-if="entry.entrytype === 'Team'">
        <a href="" @click.prevent="viewTeam(entry)">View Team</a>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem">
        <a href="" @click.prevent="deleteEntry(entry)">Delete</a>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import WaitingListApi from '@/api/waiting-list'

export default {
  name: 'WaitingListActions',
  props: {
    entry: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
  },
  methods: {
    viewTeam(entry) {
      this.$emit('show-team-modal', entry)
    },
    async moveToRoster(entry) {
      await WaitingListApi.moveToRoster(entry)
      this.$emit('deleted', entry._id)
      this.$buefy.toast.open({
        message: 'Entry moved to roster.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    deleteEntry(entry) {
      let vm = this
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this entry?',
        onConfirm: async () => {
          await WaitingListApi.deleteEntry(entry)
          vm.$emit('deleted', this.entry._id)
          this.$buefy.toast.open({
            message: 'Entry deleted successfully.',
            position: 'is-top',
            type: 'is-success',
          })
        },
      })
    },
  },
}
</script>
